module.exports = __webpack_public_path__ + "static/media/file-network.7b737033.svg";